import React, { Component, Fragment, memo } from "react";
import { withRouter } from "react-router-dom";
import Modal from "react-modal";

import MonthYearPicker from '../../../components/UI/dataPicker/monthYearPicker.jsx'

function modalMoverMes(props) {

    const customStyles = {
        content: {
            position: "fixed",
            position: "absolute",
            top: "25%",
            left: "25%",
            right: "25%",
            bottom: "25%",
            with: "50%",
            height: "50%",
            padding: "5px",
        },
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
        },
    };
    
    return (
        <Fragment>
            <Modal
                isOpen={props.showModal}
                contentLabel={props.contentLabel}
                style={customStyles}
                ariaHideApp={false}
            >
                <div className="">
                    <div className="">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={props.cerrarModal}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h2 className="modal-title" id="ModalLabel">
                                Cambiar Fecha de Asiento
                            </h2>
                        </div>
                        <div className="modal-body" style={{ textAlign: 'center' }}>
                            <div className="row">
                                <h4>Cambiar el Asiento al Mes:</h4>
                            </div>
                            <div className='row'>
                                <MonthYearPicker id="pFecha" col="12" pvalue={props.Datos.pFecha.value} attributes={props.Datos.pFecha.attributes} label={props.Datos.pFecha.attributes.label} handleChange={props.onhandleChangeDate} />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div class="tooltip2">
                                <span class="tooltiptext2">Cerrar</span>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                    onClick={props.cerrarModal}
                                >
                                    Cerrar
                                </button>
                            </div>

                            <div class="tooltip2">
                                <span class="tooltiptext2">Aceptar</span>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={props.handleAceptar}
                                >
                                    Aceptar
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </Modal>
        </Fragment>
    );
}
export default withRouter(memo(modalMoverMes))